<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$t(reportParameters[0].label)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="networkStartingPointOptions"
          :load-options="getNetworkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              technicalSiteLocalDisabled ||
              !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "NetworkDiagramWithSplicesReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "NetworkStartingPoint",
          key: "technical_local",
          type: "text",
          value: undefined
        }
      ],

      historyFilter: "detailed_synoptic"
    };
  },

  computed: {
    buttonsDisabled() {
      return this.reportParameters[0].value === undefined;
    },
    technicalSiteLocalDisabled() {
      return this.selectedWorkspace === undefined;
    },
    dataToSend() {
      return {
        type: this.historyFilter,
        version: this.version ? this.version : "excel_default_v1",
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: [
            {
              uuid: this.reportParameters[0].value,
              object_type: "technical_local"
            }
          ]
        }
      };
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);
      this.networkStartingPointOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/NetworkDiagramWithSplices.vue